module.exports = __webpack_public_path__ + "img/grade7-9.252a1a73.jpg";